import { render, staticRenderFns } from "./DataOfCPU.vue?vue&type=template&id=7dee59c6&"
import script from "./DataOfCPU.vue?vue&type=script&lang=js&"
export * from "./DataOfCPU.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports